import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Navigation } from 'swiper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as Icons from '@fortawesome/fontawesome-free-solid'
import StockImage from './img/medical-image.png'
import BiohazardBag from './img/homepage-biohazard-bag.png'
import Chair from './img/homepage-chair.png'
import GlovesBox from './img/homepage-gloves-box.png'
import TestStrips from './img/homepage-test-strips.png'
import Vial from './img/homepage-vial.png'

import './content.scss'
import 'swiper/swiper-bundle.min.css'

export default function EmeraldCategoriesMobile() {
  const [activeCategory, setActiveCategory] = useState(null)

  const changeActiveCategory = newCategory => {
    if (activeCategory?.title === newCategory?.title) {
      if (window.innerWidth < 768) {
        setActiveCategory(null)
      }
      return setActiveCategory(null)
    }
    setActiveCategory(newCategory)
  }

  const url = process.env.REACT_APP_STORAGE_URL

  const categoryData = [
    {
      title: 'Medical & Surgical Supplies',
      description:
        'Operate on healthy margins with wholesale pricing and guaranteed availability on all medical, ambulatory, post-acute, and home-based care supplies.',
      buttonLink: '/category/medsurg-supplies',
      buttonText: 'VIEW SUPPLIES',
      categoryImage: GlovesBox,
      featuredItems: [
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/787370_Nitrile_20Exam_20Gloves_cde894e6-c908-44f7-bafe-b58978ea0a29.jpg/rename/787370_Nitrile_20Exam_20Gloves_cde894e6-c908-44f7-bafe-b58978ea0a29.webp`,
          link: '/product/Nitrile-Exam-Gloves-Powder-Free-Medium-200-Bx',
          productName: 'Glove Exam Nitrile N/S Blue Medium, 200/Box',
          manufacturer: 'Dealmed',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/783022_Surgical_20Gauze_20Sponge_fcae95d0-b902-429a-992e-3e034557bacb.png/rename/783022_Surgical_20Gauze_20Sponge_fcae95d0-b902-429a-992e-3e034557bacb.webp`,
          link: '/product/Gauze-Sponge-Woven-N-S-2-x-2-8-Ply-200-Bx',
          productName: 'Surgical Sponge N/S Woven 2" x 2" 8-Ply, 200/Box',
          manufacturer: 'Dealmed',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/783811_Adhesive_20Bandages_2176c0e0-fb4b-433c-845c-e5ac04f27823.png/rename/783811_Adhesive_20Bandages_2176c0e0-fb4b-433c-845c-e5ac04f27823.webp`,
          link: '/product/Bandage-Adhesive-Fabric-1-x-3-100-Bx',
          productName: 'Bandage Adhesive Fabric 1" x 3", 100/Box',
          manufacturer: 'Dealmed',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/153061_Tape_20Surgical_20Micropore.jpg/rename/153061_Tape_20Surgical_20Micropore.webp`,
          link: '/product/3M-Micropore-Paper-Surgical-Tape-Single-Use-1-x-1-yd',
          productName: 'Tape Surgical Micropore 1" x 1.5 yds White, 100/Box',
          manufacturer: '3M',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/784021_Suture_20Removal_20Kits.jpg/rename/784021_Suture_20Removal_20Kits.webp`,
          link: '/product/Suture-Removal-Kit-Sterile-Ea',
          productName: 'Suture Removal Kit Sterile, Ea',
          manufacturer: 'Dealmed',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/784022_Staple_20Removal_20Kits.jpg/rename/784022_Staple_20Removal_20Kits.webp`,
          link: '/product/Staple-Removal-Kit-Sterile-Ea',
          productName: 'Staple Removal Kit Sterile, Ea',
          manufacturer: 'Dealmed',
        },
      ],
    },
    {
      title: 'Medical & Office Equipment',
      description:
        'Identify, save on, and get going with the ideal equipment for your services. Grow your treatment options, productivity, patient loyalty, and bottom line.',
      buttonLink: '/category/equipment-furnishings',
      buttonText: 'VIEW EQUIPMENT',
      categoryImage: Chair,
      featuredItems: [
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/167776_c521af90-1792-4880-89aa-cd212c91862d_.jpg/rename/167776_c521af90-1792-4880-89aa-cd212c91862d_.webp`,
          link: '/product/Exam-Table-204-Manual-Base-Only',
          productName: 'Exam Table Ritter 204 Manual Base Only',
          manufacturer: 'Midmark',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/461697_Connex_20Spot_20Monitor_20w_20SureBP_2C_20Nonin_20SpO2_2C_20SureTemp.jpg/rename/461697_Connex_20Spot_20Monitor_20w_20SureBP_2C_20Nonin_20SpO2_2C_20SureTemp.webp`,
          link: '/product/Connex-Spot-Monitor-w-SureBP-Nonin-SpO2-SureTemp',
          productName: 'Connex Spot Monitor w/SureBP, Nonin SpO2, SureTemp',
          manufacturer: 'Welch Allyn',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/166452_39415ad0-e08b-4aa0-a3ca-66304cbab99b_.jpg/rename/166452_39415ad0-e08b-4aa0-a3ca-66304cbab99b_.webp`,
          link: '/product/Spirometer-EasyOne-Air-Portable-Blue-Tooth',
          productName: 'Spirometer EasyOne Air Portable Blue Tooth',
          manufacturer: 'NDD Medical Technologies',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/156795_bc3e9815-03f9-4c0b-abe6-466cd44fc9c2_.jpg/rename/156795_bc3e9815-03f9-4c0b-abe6-466cd44fc9c2_.webp`,
          link: '/product/Abacus-3-CP-20-Parameter-Autoanalyzer-5-Year-Warranty',
          productName: 'Abacus 3 CP 20 Parameter Autoanalyzer 5 Year Warranty',
          manufacturer: 'Diatron',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/74b67190-84f0-441f-88e0-7cefa48cb48a.jpeg/rename/74b67190-84f0-441f-88e0-7cefa48cb48a.webp`,
          link: '/product/Analyzer-Sofia-2',
          productName: 'Analyzer Sofia 2',
          manufacturer: 'Quidel',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/49923412-f407-42bb-b674-cffc5afe6627.png/rename/49923412-f407-42bb-b674-cffc5afe6627.webp`,
          link: '/product/steam-sterilizer-m11-with-printer-178734',
          productName: 'Steam Sterilizer M11 with Printer',
          manufacturer: 'Midmark',
        },
      ],
    },
    {
      title: 'Physician Laboratory Supplies & Kits',
      description:
        'From point-of-care testing to high-performance, high-value consumables. Never run short of the exact goods you need to stay on the caring edge.',
      buttonLink: '/category/diagnostic-testing',
      buttonText: 'VIEW SUPPLIES',
      categoryImage: TestStrips,
      featuredItems: [
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/788025_BOX.png/rename/788025_BOX.webp`,
          link: '/product/strep-a-test-25-box-178731',
          productName: 'Strep A Test, 25/Box',
          manufacturer: 'Dealmed',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/Strep-A-Kit.jpg/rename/Strep-A-Kit.webp`,
          link: '/product/strep-a-test-osom-clia-waived-50-bx-178527',
          productName: 'Strep A Test Osom CLIA-waived, 50/Bx',
          manufacturer: 'Sekisui Diagnostics-Genzyme',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/3e456aa4-5ea2-4464-8abc-b0c59d616c64.jpeg/rename/3e456aa4-5ea2-4464-8abc-b0c59d616c64.webp`,
          link: '/product/COVID-19-Antigen-Test-QuickVue-SARS-25-Bx',
          productName: 'Covid Rapid Test QuickVue SARS Antigen Dipstick, 25/Bx',
          manufacturer: 'Quidel',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/469fce54-f5f2-428e-9b09-cbba9f5ec81f.jpeg/rename/469fce54-f5f2-428e-9b09-cbba9f5ec81f.webp`,
          link: '/product/strep-a-test-osom-ultra-clia-waived-25-bx-178528',
          productName: 'Strep A Test OSOM Ultra CLIA-waived, 25/Bx',
          manufacturer: 'Sekisui Diagnostics-Genzyme',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/360250_MAIN.png/rename/360250_MAIN.webp`,
          link: '/product/influenza-a-b-flu-test-status-flu-25-bx-178720',
          productName: 'Influenza A&B Flu Test Status Flu, 25/Bx',
          manufacturer: 'Lifesign',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/e37c90ef-9a03-482e-bb00-13360dc21bd9.jpeg/rename/e37c90ef-9a03-482e-bb00-13360dc21bd9.webp`,
          link: '/product/Influenza-A-B-Test-Acucy-25-Bx',
          productName: 'Influenza A&B Test Kit Acucy, 25/Bx',
          manufacturer: 'Sekisui Diagnostics-Genzyme',
        },
      ],
    },
    {
      title: 'Office Management & Supplies',
      description:
        'Get up and stay running with peace of mind that all your procedural and administrative supplies are tracked, handled and delivered.',
      buttonLink: '/category/exam-room-supplies',
      buttonText: 'VIEW EQUIPMENT',
      categoryImage: BiohazardBag,
      featuredItems: [
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/784073_Drape_20Sheet.jpg/rename/784073_Drape_20Sheet.webp`,
          link: '/product/Drape-Sheet-40-x-72-2-Ply-Tissue-White-50-Cs',
          productName: 'Drape Sheet 40" x 72" 2-Ply Tissue White, 50/Case',
          manufacturer: 'Dealmed',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/782041_Table_20Paper_20Exam.jpg/rename/782041_Table_20Paper_20Exam.webp`,
          link: '/product/Table-Paper-Smooth-21-x-225-White-12-Cs',
          productName: 'Table Paper Smooth 21" x 225\' White, 12/Case',
          manufacturer: 'Dealmed',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/cb1686c7-893f-4973-b307-d2458c0ff6bb.jpeg/rename/cb1686c7-893f-4973-b307-d2458c0ff6bb.webp`,
          link: '/product/Cup-Medicine-1-oz-100-Pk',
          productName: 'Medicine Cup 1 oz, 100/Pk',
          manufacturer: 'Dealmed',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/99038_ffab9dcd-2b17-4b1c-aa85-728c12739fbe_.jpg/rename/99038_ffab9dcd-2b17-4b1c-aa85-728c12739fbe_.webp`,
          link: '/product/Emesis-Basin-500-cc-Pink-Ea',
          productName: 'Emesis Basin 500 cc Pink, Ea',
          manufacturer: 'Dynarex',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/100953_3fe09d7e-4d23-4a26-912c-bcc279f20532_.jpg/rename/100953_3fe09d7e-4d23-4a26-912c-bcc279f20532_.webp`,
          link: '/product/Emesis-Basin-700-cc-Rose-Ea',
          productName: 'Emesis Basin 700 cc Rose, Ea',
          manufacturer: 'Misc',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/underpads_17x24.jpg/rename/underpads_17x24.webp`,
          link: '/product/Underpad-Heavy-Absorbency-17-x-24-Tissue-2-Ply-Blue-300-Cs',
          productName: 'Underpad Heavy Absorbency 17" x 24" Tissue 2-Ply Blue, 300/Case',
          manufacturer: 'Dealmed',
        },
      ],
    },
    {
      title: 'Pharmaceuticals & Supplies',
      description:
        'Take advantage of our "predictive + predictable" approach to consumables like medications and vaccines. So you\'re always stocked, pandemic or not.',
      buttonLink: '/category/pharmaceuticals',
      buttonText: 'VIEW EQUIPMENT',
      categoryImage: Vial,
      featuredItems: [
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/2d0788db-262f-49bd-834d-cdbf9e944412.jpeg/rename/2d0788db-262f-49bd-834d-cdbf9e944412.webp`,
          link: '/product/Naloxone-Narcan-HCl-Injection-USP-2mg-Prefilled-LJ-Syringe_2',
          productName: 'Naloxone (Narcan) 1 mg/mL 2 mL Needless PFS Luer-Jet, Ea',
          manufacturer: 'Amphastar/IMS',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/93730_1646d24c-c4cb-410c-be77-b60553e2ce0f_.jpg/rename/93730_1646d24c-c4cb-410c-be77-b60553e2ce0f_.webp`,
          link: '/product/DuoDote-Atropine-Pralidoxime-Auto-Inj-30-Bx',
          productName: 'DuoDote Auto-Injector, Ea',
          manufacturer: 'Meridian Medical',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/d253b13e-ef26-40fc-b88d-140db34c7d3a.jpeg/rename/d253b13e-ef26-40fc-b88d-140db34c7d3a.webp`,
          link: '/product/Calcium-Chloride-10-100-mg-mL-1-g-10-mL-Needless-PFS-Luer-Jet-Ea',
          productName: 'Calcium Chloride 10% 100 mg/mL 1 g/10 mL Needless PFS Luer-Jet, Ea',
          manufacturer: 'Amphastar/IMS',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/44a9ae56-bff3-47ca-9a8c-822e63e2a678.jpeg/rename/44a9ae56-bff3-47ca-9a8c-822e63e2a678.webp`,
          link: '/product/Diphenhydramine-50-mg-mL-1-mL-Vial-Ea',
          productName: 'Diphenhydramine 50 mg/mL 1 mL Vial, Ea',
          manufacturer: 'Hikma',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/583_dcf1d270-646b-4ad0-bc28-202f206bb1c0_.jpg/rename/583_dcf1d270-646b-4ad0-bc28-202f206bb1c0_.webp`,
          link: '/product/Aspirin-Childrens-81mg-Chewable',
          productName: 'Aspirin 81 mg EC Tablet Chew Orange, 36/Ea',
          manufacturer: 'Geri-Care Pharmaceuticals',
        },
        {
          image: `https://assets.catsy.com/fit-in/450x450/filters:format(webp):fill(white)/catsy.939/b99539c7-ed2a-499d-a026-a569e2c36c2f.jpeg/rename/b99539c7-ed2a-499d-a026-a569e2c36c2f.webp`,
          link: '/product/Cyanocobalamin-B-12-Inj-1000mcg-1-ml_2',
          productName: 'Cyanocobalamin 1,000 mcg/mL 1 mL MDV, Ea',
          manufacturer: 'Somerset',
        },
      ],
    },
  ]

  const FeaturedProductSlide = ({ data, index }) => {
    return (
      <SwiperSlide key={index} className="moe__slide">
        <a className="moe__slide-link" href={data.link}>
          <div className="moe__slide-box">
            <div className="moe__slide-image-container">
              <img
                className="moe__slide-image"
                src={data.image}
                alt={data.productName}
                loading="lazy"
              />
            </div>
            <div className="moe__slide-texts">
              <p className="moe__slide-manufacturer">{data.manufacturer}</p>
              <h4 className="moe__slide-name">{data.productName}</h4>
            </div>
          </div>
        </a>
      </SwiperSlide>
    )
  }

  const CategoryAccordionBlock = ({ data, index }) => {
    return (
      <div key={index} className="atsm__block">
        <div
          className={`atsm__accordion ${activeCategory?.title == data?.title ? 'is-open' : ''}`}
          onClick={() => changeActiveCategory(data)}
        >
          <div className="atsm__accordion-image">
            <img src={data.categoryImage} alt={data.title} loading="lazy" />
          </div>
          <div className="atsm__accordion-title">
            <h4>{data.title}</h4>
          </div>
        </div>
        <div className="atsm__accordion-content">
          <p className="atsm__accordion-desc">{data.description}</p>

          <div className="moe__slider">
            <Swiper
              className="moe__swiper"
              slidesPerView={1}
              modules={[Navigation, Pagination]}
              autoplay={false}
              spaceBetween={30}
              navigation={{
                nextEl: '.moe__navigation--next',
                prevEl: '.moe__navigation--prev',
              }}
              // navigation={true}
              breakpoints={{
                480: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                1280: {
                  slidesPerView: 3,
                },
                1400: {
                  slidesPerView: 3,
                },
              }}
            >
              <div className="moe__swiper-wrapper swiper-wrapper">
                {data.featuredItems.map((item, index) => (
                  <FeaturedProductSlide key={index} data={item} />
                ))}
              </div>
            </Swiper>
            <div className="moe__navigation">
              <div className="moe__navigation--prev swiper-button-prev">
                <FontAwesomeIcon icon="fa-solid fa-arrow-left" />
              </div>
              <div className="moe__navigation--next swiper-button-next">
                <FontAwesomeIcon icon="fa-solid fa-arrow-right" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="atsm">
      <div className="container">
        <h2 className="atsm__title">
          All the supplies, equipment, and tools your care model demands
        </h2>
        <div className="atsm__holder">
          {categoryData.map((category, index) => (
            <CategoryAccordionBlock key={index} data={category} index={index} />
          ))}
        </div>
      </div>
    </div>
  )
}
